export const environment = {
  environment: 'prod',
  msClientId: '1f243ad1-87b6-49bd-806e-24264322c41e',
  msAuthority: 'https://login.microsoftonline.com/e5d3ae7c-9b38-48de-a087-f6734a287574',
  msRedirectUri: 'https://sisreg.artemig.mg.gov.br/',
  msApiScope: 'api://d2bc1b66-653c-4ab0-af43-2f26009fd062/access_as_user',
  baseApiPath: 'https://sisreg.artemig.mg.gov.br',
};
